import React from "react";
import ListRegisterGrid from "./listRegisterGrid";
import { ListRegisterForm } from "./listRegisterForm";

const ListRegister=()=>{
    return(
        <>
        <ListRegisterForm/>
        <ListRegisterGrid/>
        </>
    )
}

export default ListRegister;